import { UserFeedback } from 'common/types'
import { post } from 'hooks/use-http/useHttp'

export const createFeedback = async (feedback: UserFeedback) => {
  const response: UserFeedback = await post('feedback', feedback, { dieSilent: true })
  return response
}

export const useFeedApi = () => {
  return {
    createFeedback
  } as const
}
